// @flow
import * as React from 'react';
import { Box } from 'grommet';
import { AccountMenu } from 'esm-web-pro/containers/layout';
import { HEADER_HEIGHT } from 'esm-web-pro/styles/theme';
import { useSelector } from 'react-redux';
import { getUser } from 'speed-js-react';
import Brand from 'esm-web-pro/components/layout/Brand';
import { withTheme } from 'styled-components';
import MainNav from './MainNav';

type Props = {
    theme: Object,
}

const Header = (props: Props) => {
    const { theme } = props;
    const user = useSelector(getUser);

    return (
        <Box
            tag="header"
            direction="row"
            align="center"
            justify="between"
            pad={{ right: user ? 'none' : 'medium' }}
            height={HEADER_HEIGHT}
        >
            <Box width={HEADER_HEIGHT} height={HEADER_HEIGHT} margin={{ right: 'medium' }}>
                <Brand
                    type="short"
                    width="30px"
                    height="30px"
                    background={{ color: theme.global.colors.brand }}
                />
            </Box>
            <MainNav />
            <Box width="384px" direction="row" justify="end">
                <Box margin={{ right: '51px' }}>
                    <AccountMenu />
                </Box>
            </Box>
        </Box>
    );
};

export default withTheme(Header);
